<template>
    <div class='style-menu'>
        <MenuHeader title='风格'/>
        <a-input-search
                placeholder="请输入搜索关键字"
                @search="onSearch"
                class='input'
        />
        <MaterialStyleList :dataList='dataList'/>
    </div>
</template>

<script>
  import MenuHeader from "../base/MenuHeader";
  import MaterialStyleList from '../base/MaterialStyleList';

  const url = 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1589173300720&di=30a2d8a8a89ab399a50a9f99b8017b6e&imgtype=0&src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F015e7b563c8e176ac7259e0f51942d.jpg%401280w_1l_2o_100sh.png';

  const dataList = Array(29).fill('').map((item, index)=>({
    url,id:index,name:index
  }));

  export default {
    name: "StyleMenu",
    components:{MenuHeader, MaterialStyleList},
    data:function(){
      return{
        dataList
      }
    },
    methods:{
      onSearch:function(event){
        console.log(event)
      }
    }
  }
</script>

<style scoped>
    .style-menu {
        width: 274px;
        padding: 12px 16px 0 16px;
        box-sizing: border-box;
        background:rgba(247,248,249,1);
        box-shadow:-1px 0 0 0 rgba(220,220,222,1);
    }
    .input{
        margin-top: 17px;
    }
</style>
